import { useEffect, useState } from "react";

/**
 * useState persisted to localStorage under `key` (JSON-serialized).
 * Falls back to `defaultValue` when nothing is stored or parsing fails.
 */
export function useLocalStorageState<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? (JSON.parse(stored) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Storage full or unavailable — keep in-memory state only
    }
  }, [key, value]);

  return [value, setValue] as const;
}
